module.exports = {
  GOOGLE: "Google Credentials",
  ACCOUNTS: "Accounts",
  CATEGORIES: "Categories",
  EXTRAS: "Extras",
  GENERATE: "Generate",
};
